import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import fa from 'vuetify/lib/locale/fa'
import ckb from 'vuetify/lib/locale/ckb'

Vue.use(VueI18n)
const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  fa: {
    ...require('@/locales/fa.json'),
    $vuetify: fa,
  },
  ar: {
    ...require('@/locales/ar.json'),
    $vuetify: fa,
  },
  ku: {
    ...require('@/locales/ku.json'),
    $vuetify: ckb,
  },
}

export default new VueI18n({
  locale: 'fa',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fa',
  silentTranslationWarn: true,
  messages,
})
